import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import GroupForm from 'components/organisms/forms/GroupForm'
import GroupEnrolledStudents from 'components/utilized/groups/GroupEnrolledStudents'
import GroupEnrolledCourses from 'components/utilized/groups/GroupEnrolledCourses'
import Tabs from 'components/organisms/tabs/Tabs'

import { crudActionsMap } from 'utils/helpers'

const GroupCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const user = useSelector((state: RootState) => state['user'].user)

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete' || user?.role === 'special_teacher'

  return (
    <>
      <PageHeading title={`${t('common.groups')} / ${t('common.' + action)}`} />
      <PageBody>
        <Tabs tabKey='group'>
          <GroupForm 
            tabText={`${t('common.group-details')}`}
            tabKey='group'
            action={action} 
            id={id} 
            viewOnly={viewOnly} />
          { id && 
            <GroupEnrolledStudents 
              tabText={`${t('common.students')}`}
              tabKey='students'
              action={action} 
              id={id} 
              viewOnly={viewOnly} /> }
          { id &&
            <GroupEnrolledCourses 
              tabText={`${t('common.enrolled-courses')}`}
              tabKey='courses'
              action={action} 
              id={id} 
              viewOnly={viewOnly} /> 
            }
        </Tabs>
      </PageBody>
    </>
  )
}
export default GroupCrudPage
